<script>
import {defineComponent, ref, watch, computed} from "vue";
import Card from "primevue/card";
import ButtonFileUpload from "@/components/buttons/ButtonFileUpload.vue";
import Textarea from 'primevue/textarea';
import {useVuelidate} from "@vuelidate/core";
import {required, site} from "@/utils/i18n-validators";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";
import InputText from "primevue/inputtext";

export default defineComponent({
  components: {
    InputText,
    ButtonFileUpload,
    Card,
    Textarea,
  },
  props: {
    type: {
      type: String,
      required: false,
    },
    slide: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    inputTitle: {
      type: String,
      required: true,
    },
    imgTitle: {
      type: String,
      required: false,
    },
    rows: {
      type: Number,
      required: true,
    },
    errors: {
      type: Object,
      required: false,
    },
    scope: {
      type: String,
      required: true,
    },
    validError: {
      type: Boolean,
      required: false,
    }
  },
  emits: ['deleteSlide', 'changeSlide'],
  setup(props, {emit}) {
    const store = useStore();

    const lang = computed(() => store.getters.getLang);

    const {t} = useI18n()
    const form = ref({...props.slide, link: props.slide.link ? props.slide.link : ''})
    const descriptionField = computed(() => props.slide.id && props.slide.id.toString().includes('new') ? `description_ru` : `description_${lang.value}`);
    const formRules = computed(() => ({
      image: {required},
      [descriptionField.value]: {required},
      link: {site}
    }))
    const v$ = useVuelidate(formRules, form.value, { $scope: props.scope });
    const deleteSlide = () => {
      emit('deleteSlide', props.index)
    }
    const loadFileMemory = (data) => {
      form.value.image = data.files[0]
    }

    watch(() => form.value,
        () => {
          emit('changeSlide', form.value, props.index)
        }, { deep: true }
    )
    watch(() => props.validError,
        async () => {
        if (props.validError)
          await v$.value.$validate();
        })
    return {
      form,
      v$,
      t,
      deleteSlide,
      loadFileMemory,
      descriptionField
    };
  }
});
</script>

<template>
  <Card>
    <template #content>
      <div class="flex justify-content-between">
        <h3>{{title}} {{index + 1}}</h3>
        <i @click="deleteSlide" class="pi pi-times cansel-button cursor-pointer" style="font-size: 1rem"></i>
      </div>
      <div class="w-full mt-4">
          <span class="p-float-label w-full">
            <Textarea
               v-model="form[descriptionField]"
               :class="['w-full', 'p-inputtext', {'p-invalid': v$[descriptionField].$errors?.length || errors?.[descriptionField]}]"
               :rows="rows"
               id="title"
            />
            <label for="title">{{inputTitle}} <i style="color: #E26B6B">*</i></label>
            </span>
          <span v-if="v$[descriptionField].$errors?.length || errors?.[descriptionField]" class="text-xs color-error">
            {{ errors?.[descriptionField] ? errors[descriptionField][0] : t(v$[descriptionField].$errors?.[0].$message) }}
          </span>
      </div>
      <div v-if="type === 'slider'" class="w-full mt-4">
          <span class="p-float-label w-full">
            <InputText
                :class="['w-full', {'p-invalid': v$.link.$errors.length || errors?.link }]"
                id="link"
                v-model="form.link"
            />
            <label for="link">Ссылка (не обязательно)</label>
            </span>
        <span v-if="v$.link.$errors.length || errors?.link" class="text-xs color-error">
            {{ errors?.link ? errors.link[0] : v$.link.$errors[0].$message }}
          </span>
      </div>
        <div class="flex flex-column mt-2 gap-2">
          <h3>{{ imgTitle ? imgTitle : 'Изображение' }} <i style="color: #E26B6B">*</i></h3>
          <span  v-if="v$.image.$errors.length || errors?.image" class="text-xs color-error">
              {{ errors?.image ? errors.image[0] : t(v$.image.$errors[0].$message) }}
          </span>
          <div v-if="form.image">
            <div>
              <img width="226" height="226" :src="form.image.preview_url ? form.image.preview_url : form.image.objectURL" />
            </div>
          </div>
          <div>
            <ButtonFileUpload
                @chooseFiles="loadFileMemory"
                :label="form.image ? 'Заменить фотографию' : 'Добавить фотографию'"
                :multiple="false"
                :clear-files-after-select="true"
                :classes="{'btn-fix-height brand__image': true}"
            />
          </div>
      </div>
    </template>
  </Card>
</template>

<style scoped>
.p-card {
  border-radius: 8px;
  box-shadow: none;
}

.p-card-title {
  font-size: 3rem !important;
}
.card__wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #DBD9D9;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}
</style>
